import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_PRAGA_DOENCA_SUCCESS,
    CANCEL_PRAGA_DOENCA_RAPIDO,
    CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS,
    TABLE_PRAGA_DOENCA_PENDING,
    TABLE_PRAGA_DOENCA_SUCCESS,
    TABLE_PRAGA_DOENCA_FAILURE,
    LIST_PRAGA_DOENCA_PENDING,
    LIST_PRAGA_DOENCA_SUCCESS,
    LIST_PRAGA_DOENCA_FAILURE,
    FIND_PRAGA_DOENCA_PENDING,
    FIND_PRAGA_DOENCA_SUCCESS,
    FIND_PRAGA_DOENCA_FAILURE,
    DELETE_PRAGA_DOENCA_PENDING,
    DELETE_PRAGA_DOENCA_SUCCESS,
    DELETE_PRAGA_DOENCA_FAILURE,
    CREATE_PRAGA_DOENCA_PENDING,
    CREATE_PRAGA_DOENCA_SUCCESS,
    CREATE_PRAGA_DOENCA_FAILURE,
    NEW_FILTER_PRAGA_DOENCA_PENDING,
    NEW_FILTER_PRAGA_DOENCA_SUCCESS,
    NEW_FILTER_PRAGA_DOENCA_FAILURE,
    NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING,
    NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS,
    NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE,
} from './actionTypes';


const initialState = {
    list: null,
    loading: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
    isCadastroRapido: false
}


function pragaDoencaReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido || false,
            }
        case CANCEL_PRAGA_DOENCA_RAPIDO:
        case CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        case LIST_PRAGA_DOENCA_PENDING:
        case FIND_PRAGA_DOENCA_PENDING:
        case DELETE_PRAGA_DOENCA_PENDING:
        case CREATE_PRAGA_DOENCA_PENDING:
        case TABLE_PRAGA_DOENCA_PENDING:
        case NEW_FILTER_PRAGA_DOENCA_PENDING:
        case NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_PRAGA_DOENCA_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_PRAGA_DOENCA_SUCCESS:
        case CREATE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { pragaDoencaReducer };